<div *ngIf="isLoaded && !enableCustomiseMessaging" class="LearnModulesOverlay">
  <div *ngIf="evaluationResult?.courseProgress?.isNewEvaluation" class="new-question-completed">
    <div class="new-question__container text-center">
      <h3 class="mb-2 mb-md-5 new-question-completed__subtitle">{{exerciseDetails?.title}}</h3>
      <ng-container *ngIf="exerciseData.rubric">
        <ng-container
          *ngIf="!(exerciseDetails?.status == 'SUBMITTED' && exerciseDetails?.assessmentType == 'TA_GRADED'); else newNotAwaited">
          <p class="font-18 font-mob-16 mb-2 navColor">Your Score</p>
          <div *ngIf="evaluationResult?.marks?.marksByExercise[exerciseId] as exerciseScore" class="mb-2 single-chart">
            <svg viewBox="0 0 36 36" class="circular-chart info">
              <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
              </path>
              <path class="circle"
                attr.stroke-dasharray="{{((exerciseScore?.gainedMarks | number:'1.0-0')/(exerciseScore?.totalMarks | number:'1.0-0'))*100}}, 100"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
            </svg>
            <div class="chart-values">
              <span class="points-value">{{exerciseScore?.gainedMarks | number:'1.0-0'}}</span>
              <span class="points-text">out of {{exerciseScore?.totalMarks | number:'1.0-0'}}</span>
            </div>
          </div>
          <p *ngIf="(exerciseDetails?.type == 'TOUCHSTONE' || exerciseDetails?.type == 'PRACTICE') && course.isNewEvaluation"
            class="mb-3"><a href="javascript:void(0)" class="underline-link montserrat-semibold primaryColor"
              (click)="openScoreFaqModal()">See how assessments work</a></p>
          <ng-container *ngIf="exerciseDetails?.type == 'TOUCHSTONE' && course.isNewEvaluation">
            <p class="font-18 font-mob-16 mb-2 navColor">What doesn't get measured, doesn't get done!</p>
            <p class="font-18 font-mob-16 mb-2 navColor">Kudos on taking up this challenge.</p>
          </ng-container>
          <ng-container *ngIf="exerciseDetails?.type == 'PRACTICE'">
            <p class="font-18 font-mob-16 mb-2 navColor">Practice makes all the difference.</p>
            <p class="font-18 font-mob-16 mb-2 navColor">Well done on staying engaged!</p>
          </ng-container>
        </ng-container>
      </ng-container>
      <div class="text-center">
        <div class="d-inline-block">
          <!-- <hr> -->
          <div class="text-center pt-4">
            <!-- <button class="btn btn-about btn-outline-primary min-width209 m-3" type="button"><span>Retake</span></button> -->
            <button *ngIf="router.url.includes('player') && nextItemId" (click)="next()"
              class="btn btn-primary min-width209 m-3" type="button"><span>Next</span></button>
          </div>
          <button (click)="scrollToFeedback()" *ngIf="showFeedback" class="btn btn-link min-width209 m-3">View
            feedback</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!evaluationResult?.courseProgress?.isNewEvaluation"
    class="d-flex justify-content-center px-3 py-5 LearnModulesOverlay" [class.noFullHeight]="fromCoursePage">
    <div class="awaiting-state text-center">
      <h6 class="awaiting-state__title mg-b30 font-24"><strong>{{exerciseDetails?.title}}</strong></h6>
      <img class="awaiting-state__icon mg-b30" src="assets/images/success2.png" alt="">

      <ng-container
        *ngIf="exerciseDetails?.status == 'SUBMITTED' && exerciseDetails?.assessmentType == 'TA_GRADED'; else notAwaited">
        <h6 class="awaiting-state__title mg-b30 font-20">{{ isMuteScores ? "Feedback" : "Score" }} Awaited</h6>
        <!-- <div class="awaiting-state__alert mg-b10">Your test is currently being evaluated by Mr XYZ</div> -->
        <p class="awaiting-state__desc font-14 lh-24 mg-b0"><strong class="font-14">Harappa Learning Specialists are
            reviewing your responses.</strong></p>
        <p class="awaiting-state__desc font-14 lh-24 mg-b0">You will receive an email when the {{ isMuteScores ? "analysis" : "grading" }} is complete.</p>
      </ng-container>

      <ng-template #notAwaited>
        <p class="awaiting-state__icon-title mg-b30">Exercise Completed</p>
        <ng-container *ngIf="exerciseData.rubric">
          <h6 *ngIf="totalExPoints  && !isMuteScores" class="awaiting-state__title mg-b30">Your Score:
            <strong>{{(totalPoints/totalExPoints)*100 |  number:'1.0-2'}}%</strong></h6>
          <p *ngIf="showFeedback" class="awaiting-state__desc mg-b50">Please see detailed feedback from Harappa Learning
            Specialists on your
            responses.</p>
        </ng-container>
      </ng-template>

      <div class="mb-3">
        <button *ngIf="router.url.includes('player')" (click)="next()" class="btn btn-primary long-btn50"
          type="button"><span>NEXT</span></button>
      </div>
      <div class="mb-0">
        <button (click)="scrollToFeedback()" *ngIf="showFeedback" type="button"
          class="btn btn-about btn-outline-primary long-btn30"><span>View
            Feedback</span></button>
      </div>
    </div>
  </div>
  <app-exercise-result *ngIf="router.url.includes('player') && showFeedback " id="resultsData" [courseId]="courseId"
    [courseTitle]="courseTitle" [exerciseId]="exerciseId" [courseFeedback]="courseFeedback"
    [exerciseData]="exerciseData">
  </app-exercise-result>
</div>

<div *ngIf="isLoaded && enableCustomiseMessaging" class="LearnModulesOverlay">
  <div *ngIf="evaluationResult?.courseProgress?.isNewEvaluation" class="new-question-completed">
    <div class="new-question__container text-center">
      <h3 class="mb-2 mb-md-5 new-question-completed__subtitle">{{exerciseDetails?.title}}</h3>
      <ng-container *ngIf="exerciseData.rubric">
        <ng-container
          *ngIf="!(exerciseDetails?.status == 'SUBMITTED' && exerciseDetails?.assessmentType == 'TA_GRADED'); else newNotAwaited">
          <p class="font-18 font-mob-16 mb-2 navColor" *ngIf="!exerciseData?.muteScores">Your Score</p>
          <ng-container *ngIf="!exerciseData?.muteScores">
          <div *ngIf="evaluationResult?.marks?.marksByExercise[exerciseId] as exerciseScore" class="mb-2 single-chart">
            <svg viewBox="0 0 36 36" class="circular-chart info">
              <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831">
              </path>
              <path class="circle"
                attr.stroke-dasharray="{{((exerciseScore?.gainedMarks | number:'1.0-0')/(exerciseScore?.totalMarks | number:'1.0-0'))*100}}, 100"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
            </svg>
            <div class="chart-values">
              <span class="points-value">{{exerciseScore?.gainedMarks | number:'1.0-0'}}</span>
              <span class="points-text">out of {{exerciseScore?.totalMarks | number:'1.0-0'}}</span>
            </div>
          </div>
        </ng-container>
          <p *ngIf="(exerciseDetails?.type == 'TOUCHSTONE' || exerciseDetails?.type == 'PRACTICE') && course.isNewEvaluation && !exerciseData?.muteFaqs"
            class="mb-3"><a href="javascript:void(0)" class="underline-link montserrat-semibold primaryColor"
              (click)="openScoreFaqModal()">See how assessments work</a></p>
          <ng-container *ngIf="exerciseDetails?.type == 'TOUCHSTONE' && course.isNewEvaluation">
            <p [froalaView]="exerciseData?.endScreenMessaging" class="font-18 font-mob-16 mb-2 navColor"></p>
          </ng-container>
          <ng-container *ngIf="exerciseDetails?.type == 'PRACTICE'">
            <p [froalaView]="exerciseData?.endScreenMessaging" class="font-18 font-mob-16 mb-2 navColor"></p>
          </ng-container>
        </ng-container>
      </ng-container>
      <div class="text-center">
        <div class="d-inline-block">
          <!-- <hr> -->
          <div class="text-center pt-4">
            <!-- <button class="btn btn-about btn-outline-primary min-width209 m-3" type="button"><span>Retake</span></button> -->
            <button *ngIf="router.url.includes('player') && nextItemId" (click)="next()"
              class="btn btn-primary min-width209 m-3" type="button"><span>{{exerciseData?.endCtaButton}}</span></button>
          </div>
          <button (click)="scrollToFeedback()" *ngIf="showFeedback" class="btn btn-link min-width209 m-3">View
            feedback</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!evaluationResult?.courseProgress?.isNewEvaluation"
    class="d-flex justify-content-center px-3 py-5 LearnModulesOverlay" [class.noFullHeight]="fromCoursePage">
    <div class="awaiting-state text-center">
      <h6 class="awaiting-state__title mg-b30 font-24"><strong>{{exerciseDetails?.title}}</strong></h6>
      <img class="awaiting-state__icon mg-b30" src="assets/images/success2.png" alt="">

      <ng-container
        *ngIf="exerciseDetails?.status == 'SUBMITTED' && exerciseDetails?.assessmentType == 'TA_GRADED'; else notAwaited">
        <h6 class="awaiting-state__title mg-b30 font-20">{{ isMuteScores ? "Feedback" : "Score" }} Awaited</h6>
        <!-- <div class="awaiting-state__alert mg-b10">Your test is currently being evaluated by Mr XYZ</div> -->
        <p class="awaiting-state__desc font-14 lh-24 mg-b0"><strong class="font-14">Harappa Learning Specialists are
            reviewing your responses.</strong></p>
        <p class="awaiting-state__desc font-14 lh-24 mg-b0">You will receive an email when the {{ isMuteScores ? "analysis" : "grading" }} is complete.</p>
      </ng-container>

      <ng-template #notAwaited>
        <p class="awaiting-state__icon-title mg-b30">Exercise Completed</p>
        <ng-container *ngIf="exerciseData.rubric">
          <h6 *ngIf="totalExPoints  && !isMuteScores" class="awaiting-state__title mg-b30">Your Score:
            <strong>{{(totalPoints/totalExPoints)*100 |  number:'1.0-2'}}%</strong></h6>
          <p *ngIf="showFeedback" class="awaiting-state__desc mg-b50">Please see detailed feedback from Harappa Learning
            Specialists on your
            responses.</p>
        </ng-container>
      </ng-template>

      <div class="mb-3">
        <button *ngIf="router.url.includes('player')" (click)="next()" class="btn btn-primary long-btn50"
          type="button"><span>{{exerciseData?.endCtaButton}}</span></button>
      </div>
      <div class="mb-0">
        <button (click)="scrollToFeedback()" *ngIf="showFeedback" type="button"
          class="btn btn-about btn-outline-primary long-btn30"><span>View
            Feedback</span></button>
      </div>
    </div>
  </div>
  <app-exercise-result *ngIf="router.url.includes('player') && showFeedback " id="resultsData" [courseId]="courseId"
    [courseTitle]="courseTitle" [exerciseId]="exerciseId" [courseFeedback]="courseFeedback"
    [exerciseData]="exerciseData">
  </app-exercise-result>
</div>


<ng-template #newNotAwaited>
  <div class="d-flex justify-content-center px-3 py-5 LearnModulesOverlay" [class.noFullHeight]="fromCoursePage">
    <div class="awaiting-state text-center">
      <img class="awaiting-state__icon mg-b30" src="assets/images/success2.png" alt="">
      <h6 class="awaiting-state__title mg-b30 font-20">{{ isMuteScores ? "Feedback" : "Score" }} Awaited</h6>
      <!-- <div class="awaiting-state__alert mg-b10">Your test is currently being evaluated by Mr XYZ</div> -->
      <p class="awaiting-state__desc font-14 lh-24 mg-b0"><strong class="font-14">Harappa Learning Specialists are
          reviewing your responses.</strong></p>
      <p class="awaiting-state__desc font-14 lh-24 mg-b0">You will receive an email when the {{ isMuteScores ? "analysis" : "grading" }} is complete.
      </p>
    </div>
  </div>
</ng-template>